import React, { FC } from 'react';
import { SkeletonBlock, SkeletonStack } from 'src/components/widgets/skeleton';
import styled from 'styled-components';

const Container = styled.div`
    padding: 10px 0;
`;

export const CategoriesSkeleton: FC = () => {
    return (
        <Container aria-hidden='true'>
            <SkeletonStack $gap='24px'>
                {['100px', '150px', '130px', '140px', '120px', '160px', '110px'].map((width, index) => (
                    <SkeletonBlock key={index} $width={width} $height='16px' $margin='2px 0 0 20px' />
                ))}
            </SkeletonStack>
        </Container>
    );
};
